import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import './assets/css/style.css';
import { useSelector } from 'react-redux';
import { BrowserRouter, useRoutes } from 'react-router-dom';
import userRoutes from './routes/userRoutes';
import authRoutes from './routes/authRoutes';

function App() {
  const isLoggedIn = useSelector((state) => state.user.isLoggedIn);
  const UserRoutesPage = () => {
    const allPages = useRoutes(userRoutes);
    return allPages;
  };

  const AuthRoutesPage = () => {
    const allPages = useRoutes(authRoutes);
    return allPages;
  };

  const queryClientOption = {
    defaultOptions: {
      queries: { refetchOnWindowFocus: false, retry: false, staleTime: 1000 * 5 },
    },
  };
  const queryClient = new QueryClient(queryClientOption);
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>{isLoggedIn ? <UserRoutesPage /> : <AuthRoutesPage />}</BrowserRouter>
    </QueryClientProvider>
  );
}

export default App;
